import { supabase } from "@/integrations/supabase/client";

/**
 * Cancela uma diária da matrícula e solta o hold correspondente, para que a
 * cota da semana continue batendo depois de uma troca de dia.
 */
export async function cancelStayDay({ dayId, contractId }: { dayId: string; contractId: string }): Promise<void> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const client = supabase as any;

  const { data: day, error: readError } = await client
    .from("stay_reservation_days")
    .select("stay_date")
    .eq("id", dayId)
    .single();
  if (readError) throw readError;

  const { error: cancelError } = await client
    .from("stay_reservation_days")
    .update({ status: "cancelled" })
    .eq("id", dayId);
  if (cancelError) throw cancelError;

  const { error: holdError } = await client
    .from("stay_reservation_daycare_plan_usages")
    .delete()
    .eq("contract_id", contractId)
    .eq("source", "hold")
    .eq("used_on", day.stay_date);
  if (holdError) throw holdError;
}
